import { Notification } from '../types/Notification';
import baseGoApi from './baseGoApi';

/**
 * Fetch all notifications for a specific user.
 * @param userId The ID of the user to fetch notifications for
 */
export const fetchNotifications = async (userId: number | string): Promise<Notification[]> => {
    const response = await baseGoApi.get(`/user/${userId}/notification`);
    // Be defensive: backend may return array, object wrapper, or undefined
    const data = response?.data as unknown;
    if (Array.isArray(data)) {
        return data as Notification[];
    }
    // Common wrapper pattern: { notifications: Notification[] }
    const maybeWrapped = (data as { notifications?: Notification[] })?.notifications;
    return Array.isArray(maybeWrapped) ? maybeWrapped : [];
};

/**
 * Delete a notification by setting its `deletedAt` field to the current date and time.
 *
 * @param id The UUID of the notification to delete.
 */
export const deleteNotification = async (id: string): Promise<void> => {
    await baseGoApi.delete(`/notifications/${id}`);
};

/**
 * Fetch the count of notifications for the current user.
 */
export const fetchNotificationCount = async (): Promise<number> => {
    const response = await baseGoApi.get(`/notifications/count`);
    return response.data.count;
};
